var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 108,
    viewBox: "0 0 107 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 105.308L104.889 107.354L106.935 105.308L104.889 103.262L102.844 105.308Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.133 105.308L79.1782 107.354L81.2235 105.308L79.1782 103.262L77.133 105.308Z",
    fill: "#0033CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4222 105.308L53.4675 107.354L55.5128 105.308L53.4675 103.262L51.4222 105.308Z",
    fill: "#0033CC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7111 105.308L27.7564 107.354L29.8017 105.308L27.7564 103.262L25.7111 105.308Z",
    fill: "#0033CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9361e-05 105.308L2.04539 107.354L4.09068 105.308L2.0454 103.262L9.9361e-05 105.308Z",
    fill: "#0033CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 79.5905L104.889 81.6363L106.935 79.5905L104.889 77.5447L102.844 79.5905Z",
    fill: "#0033CC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.133 79.5905L79.1782 81.6363L81.2235 79.5905L79.1782 77.5447L77.133 79.5905Z",
    fill: "#0033CC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4222 79.5905L53.4675 81.6363L55.5128 79.5905L53.4675 77.5447L51.4222 79.5905Z",
    fill: "#0033CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7111 79.5905L27.7564 81.6363L29.8017 79.5905L27.7564 77.5447L25.7111 79.5905Z",
    fill: "#0033CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000101609 79.5905L2.0454 81.6363L4.09069 79.5905L2.0454 77.5447L0.000101609 79.5905Z",
    fill: "#0033CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 53.8733L104.889 55.9191L106.935 53.8733L104.889 51.8275L102.844 53.8733Z",
    fill: "#0033CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.133 53.8733L79.1782 55.9191L81.2235 53.8733L79.1782 51.8275L77.133 53.8733Z",
    fill: "#0033CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4222 53.8733L53.4675 55.9191L55.5128 53.8733L53.4675 51.8275L51.4222 53.8733Z",
    fill: "#0033CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7111 53.8733L27.7564 55.9191L29.8017 53.8733L27.7564 51.8275L25.7111 53.8733Z",
    fill: "#0033CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000103858 53.8733L2.0454 55.9191L4.09069 53.8733L2.0454 51.8275L0.000103858 53.8733Z",
    fill: "#0033CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 28.1561L104.889 30.2019L106.935 28.1561L104.889 26.1103L102.844 28.1561Z",
    fill: "#0033CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M77.133 28.1561L79.1782 30.2019L81.2235 28.1561L79.1782 26.1103L77.133 28.1561Z",
    fill: "#0033CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4222 28.1561L53.4675 30.2019L55.5128 28.1561L53.4675 26.1103L51.4222 28.1561Z",
    fill: "#0033CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7111 28.1561L27.7564 30.2019L29.8017 28.1561L27.7564 26.1103L25.7111 28.1561Z",
    fill: "#0033CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000106106 28.1561L2.0454 30.2019L4.09069 28.1561L2.0454 26.1103L0.000106106 28.1561Z",
    fill: "#0033CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M102.844 2.43916L104.889 4.48495L106.935 2.43916L104.889 0.393371L102.844 2.43916Z",
    fill: "#0033CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.133 2.43915L79.1783 4.48494L81.2235 2.43915L79.1783 0.393369L77.133 2.43915Z",
    fill: "#0033CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4222 2.43915L53.4675 4.48494L55.5128 2.43915L53.4675 0.393367L51.4222 2.43915Z",
    fill: "#0033CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7111 2.43915L27.7564 4.48494L29.8017 2.43915L27.7564 0.393365L25.7111 2.43915Z",
    fill: "#0033CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000108354 2.43915L2.0454 4.48494L4.09069 2.43915L2.0454 0.393362L0.000108354 2.43915Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSDots);
export default __webpack_public_path__ + "static/media/s-dots.37275054d1047040321c3b07f936cd47.svg";
export { ForwardRef as ReactComponent };